import React, { useEffect } from 'react';

import Sidebar from './Sidebar'//import $ from "jquery";

import { Link } from 'react-router-dom';
import MainImg from '../assets/img/reset15.png'


const SetNewpin = () => {


    // useEffect(() => {
    //     window.scrollTo(0, 0)
    // }, [])


    return (
        <div>
            <div className="container">
                <div className="row mt-2">
                    <div className="col-sm-1-my text-center ">
                        <p><a href="" className="text-decoration-none"><i className="fa fa-angle-left fa-angle-left-reg" aria-hidden="true"></i></a></p>
                    </div>
                    <div className="col-sm-11-my text-center ">

                        <h3 className="font-weight-bold signin1-h1-top mt-2  ">Set New P</h3>
                    </div>

                </div>
                <div className="row page17-p">
                    <div className="col-sm-12 ">
                        {/* <hr className="mt-0" /> */}

                        <Link to="" type="button" className="text-decoration-none btn bg-red btn-danger w-100 mt-3">Send Me Email</Link>

                        <Link to="" type="button" className="text-decoration-none btn bg-red btn-danger w-100 mt-3">Send Me Text</Link>

                    </div>
                </div>

            </div>


        </div>
    )
}

export default SetNewpin;